import React, { useEffect, useState } from 'react';

export default function ContextMenu({ x, y, items, onClose }) {
  const [pos, setPos] = useState({ x, y });

  useEffect(() => {
    const timer = setTimeout(() => {
      document.addEventListener('click', onClose);
      return () => document.removeEventListener('click', onClose);
    }, 0);
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className="context-menu" style={{ left: pos.x, top: pos.y }} onContextMenu={e => e.preventDefault()}>
      {items.map((item, i) => (
        <button
          key={i}
          className={`context-menu-item ${item.danger ? 'danger' : ''}`}
          onClick={() => { item.action(); onClose(); }}
        >
          {item.icon && <span className="context-icon">{item.icon}</span>}
          <span>{item.label}</span>
        </button>
      ))}
    </div>
  );
}
